import React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IAmbienceMenuState } from "../IAmbienceMenuState";

export function NextAmbienceIcon() {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.forward}
            whenClicked={() => {
                State.ReadClass<IAmbienceMenuState>(
                    ESharedComponent.AmbienceMenu
                ).setState({ selectedAmbience: undefined }, () => {
                    Ambience.Stop();
                    Ambience.StartNextAmbience();
                });
            }}
            displayAsBlock
            customStyle={{ margin: 0 }}
            customSound={Sounds.electronic_tone_soft}
        />
    );
}
